export const USER_TYPE_COLORS = {
  GREY: "#9F9F9F",
  AQUA: "#24bFd0",
  GREEN: "#15AA4E",
  MAROON: "#7f1c53",
};
